import angular from 'angular';

import kaasModule from './kaas';

export default angular.module('portainer.environments.components', [kaasModule])
  .name;
